<template>
	<section>
		<div class="mb-5 border-2 rounded-lg border-neutral-800 bg-neutral-800">
			<div class="px-5 py-4">
				<h5 class="mb-0 font-medium leading-none text-white">
					{{
						$t('personality-results.accordions.key-trait-alignment')
					}}
				</h5>
			</div>

			<div class="p-5 space-y-6 rounded-b-lg bg-neutral-900">
				<OverlappingTraitsAccordion
					v-for="(trait, index) in overlappingTraits"
					:key="index"
					:row="trait"
				/>
			</div>
		</div>
	</section>
</template>

<script>
import personalityResults from '~/mixins/personalityResults'
import OverlappingTraitsAccordion from './OverlappingTraitsAccordion'

export default {
	name: 'OverviewPanelComparison',
	components: {
		OverlappingTraitsAccordion
	},
	mixins: [personalityResults],
	props: {
		jobOfferData: {
			type: Object,
			default: () => {}
		},
		applicantData: {
			type: Object,
			default: () => {}
		},
		matchData: {
			type: Object,
			default: () => {}
		},
		wheelMode: {
			type: String,
			required: true
		}
	}
}
</script>
